// Дрон "Щит Танаки" — trigger: «Когда этот юнит получает урон: Герой +1 Влияния».
// Срабатывает столько раз, сколько раз получил урон.
// А.5-fix1: понижено с +2 до +1 (баланс).

import { addInfluence } from './influence.js';

export const CARD_ID = 'deus_dron_schit_tanaki';

export function dronOnDamage(state, ownerIdx) {
  addInfluence(state, ownerIdx, 1, 'Дрон-щит [получил урон]');
}
